import { Icon, Popup, type PopupProps } from '@mairistem/composants';

const PopupRGPD = (props: PopupProps) => (
  <Popup
    mouseEnterDelay={100}
    content={
      <>
        <span>
          <span style={{ fontWeight: 'bold' }}>RGPD</span> : Ce champ permet de mettre un
          commentaire sur le profil du payeur.
        </span>
        <br />
        <br />
        <span style={{ fontStyle: 'italic' }}>
          Il ne doit pas contenir d&apos;informations d&apos;ordre personnel.
        </span>
      </>
    }
    trigger={<Icon name="shield" />}
    wide="very"
    position="top left"
    {...props}
  />
);

export default PopupRGPD;
